import React from 'react';
import { Check, CheckCheck } from 'lucide-react';
interface MessageBubbleProps {
  content: string;
  timestamp: string;
  isSent: boolean;
  status?: 'sent' | 'delivered' | 'read';
}
export function MessageBubble({
  content,
  timestamp,
  isSent,
  status = 'read'
}: MessageBubbleProps) {
  return <div className={`flex flex-col ${isSent ? 'items-end' : 'items-start'} mb-4`} data-id="element-114">
      <div className={`max-w-[75%] px-4 py-2 rounded-2xl shadow-sm ${isSent ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-br-none' : 'bg-white border border-gray-100 text-gray-900 rounded-bl-none'}`} data-id="element-115">
        <p className="text-sm leading-relaxed" data-id="element-116">{content}</p>
      </div>
      <div className="flex items-center mt-1 space-x-1" data-id="element-117">
        <span className="text-[10px] text-muted-foreground" data-id="element-118">{timestamp}</span>
        {isSent && <span className="text-muted-foreground" data-id="element-119">
            {status === 'read' ? <CheckCheck className="h-3 w-3 text-blue-500" data-id="element-120" /> : <Check className="h-3 w-3" data-id="element-121" />}
          </span>}
      </div>
    </div>;
}